// 后端的值类型枚举
export enum RAW_VALUE_TYPE {
  // 文本-固定值
  FIXED = 'fixed',

  // 图片标签-固定值
  IMAGE_FIXED = 'image_fixed',

  // 动态值
  DYNAMICS = 'dynamics',

  // 图片标签-动态值
  IMAGE_DYNAMICS = 'image_dynamics',

  // 多个值
  MULTIPLE = 'multiple',

  // 随机码
  SKU = 'sku',

  // 随机码
  SPU = 'spu',

  FIX_SN = 'fix_sn',

  SPU_FIX = 'spu_fix',
}

export enum TEMPLATE_TYPE {
  TIKTOK = 'tiktok',
  TIKTOK_FULL = 'tiktok_full',
  TIKTOK_LOCAL = 'tiktok_local',
  SHOP_LINE = 'shopline',
  TEMU = 'temu',
  TEMU_LOCAL = 'temu_local',
  SHEIN = 'shein',
  AMAZON = 'amazon',
}

/** 新增店铺所属平台展示文案（含适用于说明） */
export const SHOP_PLATFORM_DISPLAY_MAP: Record<
  string,
  {
    label: string;
    desc?: string;
  }
> = {
  [TEMPLATE_TYPE.TEMU]: {
    label: 'Temu',
    desc: '适用于：全托、半托',
  },
  [TEMPLATE_TYPE.TIKTOK]: {
    label: 'Tiktok跨境',
    desc: '适用于：跨境（美/欧/日/墨/东南亚）',
  },
  [TEMPLATE_TYPE.TIKTOK_LOCAL]: {
    label: 'TikTok本土',
    desc: '适用于：本土（美/欧/日/东南亚）',
  },
  [TEMPLATE_TYPE.TIKTOK_FULL]: {
    label: 'TikTok全托',
    desc: '适用于：全托管、品牌托管、本地托管',
  },
  [TEMPLATE_TYPE.SHEIN]: {
    label: 'Shein',
    desc: '适用于：全托、半托、自运营',
  },
};

/** TikTok 跨境店铺区域说明（纯前端展示，提交不传值） */
export const TIKTOK_STORE_REGION_TEXT =
  '支持美国、欧洲（英国、德国、意大利、西班牙、法国）、日本、墨西哥、东南亚（菲律宾、马来西亚、越南、泰国、新加坡、印度尼西亚）';

/** TikTok 本土店铺区域（提交 region 字段） */
export enum TIKTOK_LOCAL_REGION {
  US = 'US',
  AS = 'AS',
  EU = 'EU',
  GLOBAL = 'GLOBAL',
}

export const TIKTOK_LOCAL_REGION_OPTIONS = [
  {
    label: '美国',
    value: TIKTOK_LOCAL_REGION.US,
  },
  {
    label: '日本、东南亚（菲律宾、马来西亚、越南、泰国、新加坡）',
    value: TIKTOK_LOCAL_REGION.AS,
  },
  {
    label: '欧洲（德国、西班牙、法国、意大利、爱尔兰、英国、葡萄牙等国）',
    value: TIKTOK_LOCAL_REGION.EU,
  },
];

/** 临时白名单：可见「欧洲」区域的团队 ID 白名单 */
const TIKTOK_LOCAL_EU_ORG_IDS = ['9031501207557247947', '1'];

/** 按组织权限过滤 TikTok 本土店铺区域选项 */
export function getTiktokLocalRegionOptions(orgId?: string | number) {
  const allowed = TIKTOK_LOCAL_EU_ORG_IDS.includes(String(orgId ?? ''));
  return TIKTOK_LOCAL_REGION_OPTIONS.filter((o) => o.value !== TIKTOK_LOCAL_REGION.EU || allowed);
}

/** Temu 本土店铺区域 */
export enum TEMU_LOCAL_REGION {
  US = 'US',
}

export const TEMU_LOCAL_REGION_OPTIONS = [{ label: '美国', value: TEMU_LOCAL_REGION.US }];

/** TikTok 全托店铺业务类型 */
export enum TIKTOK_SELLER_TYPE {
  FULL = 'full',
  BRAND = 'brand',
  LOCAL = 'local',
}

export const TIKTOK_SELLER_TYPE_OPTIONS = [
  { label: '全托管', value: TIKTOK_SELLER_TYPE.FULL },
  { label: '品牌托管', value: TIKTOK_SELLER_TYPE.BRAND },
  { label: '本地托管', value: TIKTOK_SELLER_TYPE.LOCAL },
];

// 值类型枚举
export enum VALUE_TYPE {
  // 固定值
  FIXED = RAW_VALUE_TYPE.FIXED,

  // 动态值
  DYNAMICS = RAW_VALUE_TYPE.DYNAMICS,

  // 多个值
  MULTIPLE = RAW_VALUE_TYPE.MULTIPLE,
}

export const RAW_MAP = {
  [RAW_VALUE_TYPE.FIXED]: VALUE_TYPE.FIXED,
  [RAW_VALUE_TYPE.DYNAMICS]: VALUE_TYPE.DYNAMICS,
  [RAW_VALUE_TYPE.IMAGE_FIXED]: VALUE_TYPE.FIXED,
  [RAW_VALUE_TYPE.IMAGE_DYNAMICS]: VALUE_TYPE.DYNAMICS,
};

// 值类型下拉选项
export const VALUE_TYPE_OPTIONS = [
  {
    label: '固定值',
    value: VALUE_TYPE.FIXED,
  },
  {
    label: '动态值',
    value: VALUE_TYPE.DYNAMICS,
  },
];

// 包含多个值的类型下拉选项
export const VALUE_TYPE_OPTIONS_MUL = [
  {
    label: '固定值',
    value: VALUE_TYPE.FIXED,
  },
  {
    label: '动态值',
    value: VALUE_TYPE.DYNAMICS,
  },
  {
    label: '多个值',
    value: VALUE_TYPE.MULTIPLE,
  },
];

// 富文本类型枚举
export enum RICHTEXT_TYPE {
  // 文本
  TEXT = 'text',

  // 图片标签
  IMAGE_TAG = 'image_tag',
}

// 富文本类型选项
export const RICHTEXT_TYPE_OPTIONS = [
  {
    label: '文本',
    value: RICHTEXT_TYPE.TEXT,
  },
  {
    label: '图片',
    value: RICHTEXT_TYPE.IMAGE_TAG,
  },
];

// 动态值类型枚举
export enum DYNAMICS_VALUE_TYPE {
  // 结果图 / 现展示名：轮播图 (images-${number})
  IMAGES = 'images',

  // 商品来源图 / 原轮播图 (goodsImages_image-${number})
  GOODS_IMAGES_IMAGE = 'goodsImages_image',

  // 商品去水印图(goodsImages_watermark-${number})
  GOODS_IMAGES_WATERMARK = 'goodsImages_watermark',

  // 商品换背景图(goodsImages_change_background-${number})
  GOODS_IMAGES_CHANGE_BACKGROUND = 'goodsImages_change_background',

  // 商品全能改图(goodsImages_part_replace-${number})
  GOODS_IMAGES_PART_REPLACE = 'goodsImages_part_replace',

  // 商品裁剪压缩图(goodsImages_compress-${number})
  GOODS_IMAGES_COMPRESS = 'goodsImages_compress',

  // 采集图片(goodsImages_crawling-${number})
  GOODS_IMAGES_CRAWLING = 'goodsImages_crawling',

  // 原图
  ORIGINAL = 'original',

  // 印花图
  PRINTING = 'printing',

  // 标题(titles-${string})
  TITLES = 'titles',

  // // 原标题
  // TITLE = 'title',

  // // 中文标题
  // CN_TITLE = 'cnTitle',

  // // 英文标题
  // EN_TITLE = 'enTitle',

  // 名称
  NAME = 'name',
}

// 需要选择“第几张”的动态图片类型
export const DYNAMICS_INDEXED_IMAGE_VALUE_TYPES: string[] = [
  DYNAMICS_VALUE_TYPE.IMAGES,
  DYNAMICS_VALUE_TYPE.GOODS_IMAGES_IMAGE,
  DYNAMICS_VALUE_TYPE.GOODS_IMAGES_WATERMARK,
  DYNAMICS_VALUE_TYPE.GOODS_IMAGES_CHANGE_BACKGROUND,
  DYNAMICS_VALUE_TYPE.GOODS_IMAGES_PART_REPLACE,
  DYNAMICS_VALUE_TYPE.GOODS_IMAGES_COMPRESS,
  DYNAMICS_VALUE_TYPE.GOODS_IMAGES_CRAWLING,
];

export function getDefaultValueByValueType(valueType: RAW_VALUE_TYPE) {
  if ([RAW_VALUE_TYPE.DYNAMICS, RAW_VALUE_TYPE.IMAGE_DYNAMICS].includes(valueType)) {
    return 'images-1';
  }
  return '';
}

export function getTitleByValue(value: string) {
  const titles = value.split('-');
  if (titles.length === 2) {
    const t = findDynamicsOption(DYNAMICS_VALUE_TYPE_OPTIONS, titles[0])?.label;
    return t ? t + '-' + titles[1] : value;
  }
  return findDynamicsOption(DYNAMICS_VALUE_TYPE_OPTIONS, value)?.label || value;
}

export function findDynamicsOption(
  options: {
    label: string;
    value: string;
    description?: string;
    children?: { label: string; value: string; description?: string }[];
  }[] = [],
  value?: string
) {
  if (!value) return undefined;
  for (const option of options) {
    if (option.value === value) return option;
    const child = option.children?.find((item) => item.value === value);
    if (child) return child;
  }
  return undefined;
}

// 动态值类型下拉选项
export const DYNAMICS_VALUE_TYPE_OPTIONS = [
  {
    label: '轮播图',
    value: DYNAMICS_VALUE_TYPE.IMAGES,
    description: '原结果图，商品最终生成图片',
  },
  {
    label: '来源图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_IMAGE,
    description: '商品库的原始图片',
  },
  {
    label: '裁剪压缩图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_COMPRESS,
    description: '从商品库进行裁剪压缩的结果图',
  },
  {
    label: '去水印图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_WATERMARK,
    description: '从商品库进行去水印的结果图',
  },
  {
    label: '换背景图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_CHANGE_BACKGROUND,
    description: '从商品库进行换背景的结果图',
  },
  {
    label: '全能改图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_PART_REPLACE,
    description: '从商品库进行全能改图的结果图',
  },
  {
    label: '原图',
    value: DYNAMICS_VALUE_TYPE.ORIGINAL,
  },
  {
    label: '印花图',
    value: DYNAMICS_VALUE_TYPE.PRINTING,
  },
  {
    label: '采集图片',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_CRAWLING,
  },
  {
    label: '标题',
    value: DYNAMICS_VALUE_TYPE.TITLES,
  },
  {
    label: '名称',
    value: DYNAMICS_VALUE_TYPE.NAME,
  },
];

// 动态值类型下拉选项，只包含文本相关
export const DYNAMICS_TEXT_VALUE_TYPE_OPTIONS = [
  {
    label: '标题',
    value: DYNAMICS_VALUE_TYPE.TITLES,
  },
  {
    label: '名称',
    value: DYNAMICS_VALUE_TYPE.NAME,
  },
];

// 动态值类型下拉选项，只包含图片相关（刊登模板）
export const DYNAMICS_IMAGE_VALUE_TYPE_OPTIONS = [
  {
    label: '轮播图',
    value: DYNAMICS_VALUE_TYPE.IMAGES,
    description: '原结果图，商品最终生成图片',
  },
  {
    label: '来源图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_IMAGE,
    description: '商品库的原始图片',
  },
  {
    label: '裁剪压缩图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_COMPRESS,
    description: '从商品库进行裁剪压缩的结果图',
  },
  {
    label: '去水印图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_WATERMARK,
    description: '从商品库进行去水印的结果图',
  },
  {
    label: '换背景图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_CHANGE_BACKGROUND,
    description: '从商品库进行换背景的结果图',
  },
  {
    label: '全能改图',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_PART_REPLACE,
    description: '从商品库进行全能改图的结果图',
  },
  {
    label: '原图',
    value: DYNAMICS_VALUE_TYPE.ORIGINAL,
  },
  {
    label: '印花图',
    value: DYNAMICS_VALUE_TYPE.PRINTING,
  },
  {
    label: '采集图片',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_CRAWLING,
  },
];

// 导出模板动态值类型下拉选项（商品库图组为二级菜单）
export const EXPORT_DYNAMICS_IMAGE_VALUE_TYPE_OPTIONS = [
  {
    label: '轮播图',
    value: DYNAMICS_VALUE_TYPE.IMAGES,
    description: '原结果图，商品最终生成图片',
  },
  {
    label: '商品库图组',
    value: 'goodsImagesGroup',
    description: '由商品库生成的图片组',
    children: [
      {
        label: '来源图',
        value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_IMAGE,
        description: '商品库的原始图片',
      },
      {
        label: '裁剪压缩图',
        value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_COMPRESS,
        description: '从商品库进行裁剪压缩的结果图',
      },
      {
        label: '去水印图',
        value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_WATERMARK,
        description: '从商品库进行去水印的结果图',
      },
      {
        label: '换背景图',
        value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_CHANGE_BACKGROUND,
        description: '从商品库进行换背景的结果图',
      },
      {
        label: '全能改图',
        value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_PART_REPLACE,
        description: '从商品库进行全能改图的结果图',
      },
    ],
  },
  {
    label: '原图',
    value: DYNAMICS_VALUE_TYPE.ORIGINAL,
  },
  {
    label: '印花图',
    value: DYNAMICS_VALUE_TYPE.PRINTING,
  },
  {
    label: '采集图片',
    value: DYNAMICS_VALUE_TYPE.GOODS_IMAGES_CRAWLING,
  },
];

export function getRawValueTypeByValueTypeAndRichTextType(options: {
  valueType: VALUE_TYPE;
  richTextType?: RICHTEXT_TYPE;
}) {
  const { valueType, richTextType } = options;
  if (valueType === VALUE_TYPE.MULTIPLE) {
    return VALUE_TYPE.MULTIPLE;
  }
  if (richTextType === RICHTEXT_TYPE.IMAGE_TAG) {
    if (valueType === VALUE_TYPE.FIXED) {
      return RAW_VALUE_TYPE.IMAGE_FIXED;
    }
    return RAW_VALUE_TYPE.IMAGE_DYNAMICS;
  }

  if (valueType === VALUE_TYPE.FIXED) {
    return RAW_VALUE_TYPE.FIXED;
  }

  return RAW_VALUE_TYPE.DYNAMICS;
}

export function getValueTypeByRawValueType(type: RAW_VALUE_TYPE) {
  if (type === RAW_VALUE_TYPE.MULTIPLE) {
    return RAW_VALUE_TYPE.MULTIPLE;
  }
  if ([RAW_VALUE_TYPE.FIXED, RAW_VALUE_TYPE.IMAGE_FIXED].includes(type)) {
    return VALUE_TYPE.FIXED;
  }

  return VALUE_TYPE.DYNAMICS;
}

export function getRichtextTypeByRawValueType(type: RAW_VALUE_TYPE) {
  if ([RAW_VALUE_TYPE.IMAGE_FIXED, RAW_VALUE_TYPE.IMAGE_DYNAMICS].includes(type)) {
    return RICHTEXT_TYPE.IMAGE_TAG;
  }

  return RICHTEXT_TYPE.TEXT;
}
